<template>
    <modal class="promotionalGiveModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">满赠 <span class="title">—本次点单{{maxGitNum>0?'已':'未'}}达到满赠活动【{{data?.PromotionName}}】</span></div>
        <div class="modal-body">
            <!-- <div class="title"></div> -->
            <div class="tip-box">
                活动菜品{{(giftProm.PromKindType==1 || giftProm.PromKindType==4)?"每":""}}满
                <span class="num">{{giftProm.NeedOrderInNum}}</span>
                {{(giftProm.PromKindType==3 || giftProm.PromKindType==4)?"元":"份"}}赠送
                <span class="num">{{giftProm.GiftNum}}</span>
                份，最多可赠送
                <span class="num">{{maxGitNum}}</span>
                份，请选择赠送菜品</div>
            <div class="content-box">
                <div class="select-item-box">
                    <div class="tit">可赠送菜品</div>
                    <div class="table-box">
                        <el-table class="el-table--scrollable-y" :data="GiftFoods" max-height="270" style="width: 100%;">
                            <el-table-column prop="Food_Name" align="left" label="菜品名称" min-width="120" ></el-table-column>
                            <el-table-column prop="Food_Size"  align="center" label="单位" width="80" ></el-table-column>
                            <el-table-column align="center" label="操作" width="100">
                                <template #default="scope">
                                    <div class="add-bnt" v-show="isAddItem || itemKeys[scope.row.Food_ID]" @click="addItem(scope.row)">选择</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="flex1">
                    <div class="tit">已选菜品：{{total.number}}份</div>
                    <div class="table-box">
                        <el-table class="el-table--scrollable-y" :data="selectItems" max-height="270" style="width: 100%;">
                            <el-table-column prop="Food_Name" align="left" label="菜品名称" min-width="120"></el-table-column>
                            <el-table-column prop="Food_Size" align="center" label="单位" width="80" ></el-table-column>
                            <el-table-column align="center" label="数量" min-width="100" >
                                <template #default="scope">
                                    <key-board-input  v-model="scope.row.number" pattern="number" :dplaces="0" :min="1" 
                                    :keyOptions="{isNumber:true,isKeyDownEnter:true}" 
                                    isBlurClose isKeyEnterClose/>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="操作" width="80">
                                <template #default="scope">
                                    <i class="iconfont icon-shanchu" @click="delItem(scope)"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="cancel()">放弃优惠并返回</button>
            <button class="btn btn-confirm" @click="confirm()">确定</button>
        </div>
    </modal>
</template>
  
<script>
export default {
    emits:["close","cancel","confirm"],
    name:'promotionalGiveModel',
    props:{
        isShow:{
            type:Boolean,
            dafault:false
        },
        /**
         * 传入优惠活动
         * 
        */
        data:{
            type:Object,
            dafault:null
        },
        /**所有的菜品数据 */
        allFoods:{
            type:Array,
            dafault:null
        },
        /**活动最多能送多少份 */
        maxGitNum:{
            type:Number,
            dafault:0
        }
    },
    computed:{
        /**活动方案 */
        giftProm(){
            return this.data?.MoneyGiftPromotion||{};
        },
        itemKeys(){
            let keys={};
            this.selectItems.forEach(it=>{
                keys[it.Food_ID]=it;
            })
            return keys;
        },
        /**是否可以继续添加菜品 */
        isAddItem(){
            let GiftRule=this.data?.MoneyGiftPromotion?.GiftRule;
            return (GiftRule==0 && (this.selectItems||[]).length==0) || GiftRule==1;
        },
        /**合计 */
        total(){
            let total={
                number:0
            };
            this.selectItems.forEach(it=>{
                total.number=Number(it.number).compute(total.number);
            })
            return total;
        }
    },
    data(){
        return{
            /***可赠送的菜 */
            GiftFoods:[],
            //赠送的菜
            selectItems:[]
        }
    },
    watch:{
        isShow(){
            this.init();
        }
    },
    mounted(){
        this.$nextTick(()=>{
           this.init();
        })
    },
    methods:{
        init(){
            if(this.isShow){
                let giftFoods=[];
                this.data?.MoneyGiftPromotion?.GiftFoods?.forEach((it)=>{
                    this.allFoods.some(item=>{
                        if(item.Food_ID==it.Item_ID){
                            giftFoods.push(item);
                            return true;
                        }
                        return item.MultipleSizeFoods?.some(mItem=>{
                            if(mItem.Food_ID==it.Item_ID){
                                giftFoods.push(mItem);
                                return true;
                            }
                        })
                    })
                })
                this.GiftFoods=giftFoods;
                //赠送的菜
                this.selectItems=this.data?.promGiveItems||[];
            }
        },
        hide(){
            this.$emit("close");
        },
        /**选中 赠送菜 */
        addItem(row){
            console.log(row)
            if(this.maxGitNum<=this.total.number){
                this.$message.warning('已达到最多赠送份数!');
                return;
            }

            if(!this.itemKeys[row.Food_ID]){
                this.selectItems.push(Object.assign({},row,{number:1}));
            }else{
                this.itemKeys[row.Food_ID].number= Number(this.itemKeys[row.Food_ID].number).compute(1);
            }
            
        },
        /**删除 赠送的菜 */
        delItem({$index}){
            this.selectItems.splice($index,1);
        },
        //放弃优惠活动
        cancel(){
            this.$emit("cancel");
        },
        //确认
        confirm(){
            if(this.maxGitNum<this.total.number){
                this.$message.warning('超过最多赠送份数!');
                return;
            }
            try {
                this.selectItems.forEach(it=>{
                    if(!(it.number>0)){
                        throw {message:`【${it.Food_Name}】赠送数量不能为0,请最少赠送1份`};
                    }
                    if(it.Is_SoldOut){
                        throw {message:`【${it.Food_Name}】该菜品已售完`};
                    }
                    //限量销售的菜 剩余数量 0  有限量销售方案 true:是
                    if(it.Is_Limited && it.RemainNum==0 && it.Is_LimitedProject){
                        throw {message:`【${it.Food_Name}】该菜品已售完`};
                    }
                })
            } catch (error) {
                this.$message.warning(error.message);
                return;
            }
            
            this.$emit("confirm",this.selectItems);
        }
    }
}
</script>
<style lang="scss">
    @import "./promotionalGiveModel.scss"
</style>